import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { NavLink, useLocation } from 'react-router-dom';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';
import { breakpoints } from '@sorted/sorted-ui';
import colors from '../Sidebar/colors';
import Logo from '../Sidebar/assets/sorted-logo-and-text.svg';
import MenuPanel from './Menu';

const StyledLogo = styled(Logo)`
	height: 40px;
	fill: ${colors.white};
`;

const ToggleMenuButton = styled.button`
	border: 0;
	cursor: pointer;
	background: transparent;
	outline: none;

	svg {
		fill: ${props => (props.isActive ? colors.pink : colors.white)};
	}
`;

const headerHeight = '60px';

const MobileHeaderContainer = styled.header`
	background-color: ${colors.logoBg};
	height: ${headerHeight};
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 998;

	@media (min-width: ${breakpoints.smallDesktop}) {
		display: none;
	}
`;

const Content = styled.div`
	padding: 0 16px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 100%;
`;

const MobileHeader = () => {
	const [menuOpen, setMenuOpen] = useState(false);

	const location = useLocation();

	useEffect(() => {
		setMenuOpen(false);
	}, [location]);

	return (
		<MobileHeaderContainer>
			<Content>
				<NavLink to="/">
					<StyledLogo />
				</NavLink>
				<ToggleMenuButton
					aria-label="Show/Hide Menu"
					isActive={menuOpen}
					onClick={() => setMenuOpen(!menuOpen)}
					role="button"
				>
					{menuOpen ? <CloseIcon /> : <MenuIcon />}
				</ToggleMenuButton>
			</Content>
			<MenuPanel
				isOpen={menuOpen}
				onHide={() => setMenuOpen(false)}
				headerHeight={headerHeight}
			/>
		</MobileHeaderContainer>
	);
};

export default MobileHeader;
